import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {useStaticQuery, graphql} from 'gatsby';
import {LocaleContext} from '../../context';

export function PureMarkdownTable({data, id}) {
    const locale = useContext(LocaleContext);
    const md = data.allContentfulMarkdownTable.nodes.find(
        (node) => node.contentful_id === id && node.node_locale === locale,
    );

    if (!md) {
        return null;
    }

    const {html} = md.content.childMarkdownRemark;
    const TABLE_TAG_REGEX = /(<\s*table)([^>]*>)/;
    const markupWithClass = html.replace(TABLE_TAG_REGEX, '$1 class="table"$2');
    return (
        <div
            className="table-responsive"
            dangerouslySetInnerHTML={{
                __html: markupWithClass,
            }}
        />
    );
}

PureMarkdownTable.propTypes = {
    data: PropTypes.shape({
        allContentfulMarkdownTable: PropTypes.shape({
            nodes: PropTypes.arrayOf(
                PropTypes.shape({
                    contentful_id: PropTypes.string.isRequired,
                    node_locale: PropTypes.string.isRequired,
                    content: PropTypes.shape({
                        childMarkdownRemark: PropTypes.shape({
                            html: PropTypes.string.isRequired,
                        }).isRequired,
                    }).isRequired,
                }),
            ).isRequired,
        }).isRequired,
    }).isRequired,
    id: PropTypes.string.isRequired,
};

export function Markdown(props) {
    const data = useStaticQuery(graphql`
        query {
            allContentfulMarkdownTable {
                nodes {
                    contentful_id
                    node_locale
                    content {
                        childMarkdownRemark {
                            html
                        }
                    }
                }
            }
        }
    `);

    return <PureMarkdownTable data={data} {...props} />;
}

Markdown.propTypes = {
    id: PropTypes.string.isRequired,
};
